import { selectErrorStatus } from 'affiny-core/redux/selectors/asyncStateSelectors';
import React, { FC, ReactNode } from 'react';
import { IAsyncStatusHandlerProps } from './AsyncStatusHandler.types';

// TODO this component should handle everything linked to asynchronous calls (loading state, toaster display, etc.)
export const AsyncStatusHandler: FC<
  IAsyncStatusHandlerProps & {
    children: ReactNode;
  }
> = ({ breakers, children, error, isLoading, LoaderComponent }) => {
  const errorStatus = selectErrorStatus(error);

  if (isLoading && LoaderComponent) return <LoaderComponent isLoading />;

  if (!errorStatus) {
    return <>{children}</>;
  }

  return breakers && breakers[errorStatus] ? breakers[errorStatus] : null;
};
